


// import React, { useEffect, useState } from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
//     Divider,
// } from "@mui/material";
// import { CancelSharp, Close as CloseIcon, Description } from "@mui/icons-material";
// import { Formik, Form, useFormikContext } from "formik";

// import { FaPlus } from "react-icons/fa6";
// import { MdPayment } from "react-icons/md";

// import './EditProfileModal.css'; // Import external CSS
// // import "../../../../Components/ModalCss/BannerinputGetModal.css";

// import { MdCancel } from "react-icons/md";
// import * as Yup from "yup";
// import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
// import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
// import { toast, ToastContainer } from "react-toastify";
// import actions from "../../../ReduxStore/actions";
// import { useDispatch, useSelector } from "react-redux";
// import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
// import { updateAwardAction } from "../../../ReduxStore/Slices/EditProfile/updateAward";
// import CustomRadioButton from "../../../Components/CustomRadioButton/CustomRadioButton";
// import CustomFromAndToDate from "../../../Components/CustomFromAndToDate/CustomFromAndToDate";
// import CustomIsCurrentorNotFromToDate from "../../../Components/CustomFromAndToDate/CustomIsCurrentorNotFromToDate";
// import CustomAddMultipleInputs from "../../../Components/CustomInputLogin/CustomAddMultipleInputs";
// const validationSchema = Yup.object().shape({
//     description: Yup.string().required("Description is required"),
//     institute_name: Yup.string().required("Institute name is required"),
//     degree: Yup.string().required("Degree is required"),
//     field_of_study: Yup.string().required("Field of study is required"),
//     isCurrent: Yup.string().oneOf(["yes", "no"]).required("Current status is required"),
//     // fromDate: Yup.date()
//     //     .required("From Date is required")
//     //     .typeError("Invalid date format"),
//     // toDate: Yup.date()
//     //     .when("isCurrent", {
//     //         is: "no",
//     //         then: Yup.date()
//     //             .required("To Date is required")
//     //             .typeError("Invalid date format")
//     //             .min(Yup.ref("fromDate"), "To Date cannot be before From Date"),
//     //         otherwise: Yup.date().notRequired(),
//     //     }),
// });
// const EditProfileAboutMeModal = ({
//     open,
//     onClose,
//     setSubmittedValues,
//     submittedValues,
//     skillsData,
//     setSkillsData,
//     uploadedFile,
//     setUploadedFile
// }) => {
//     console.log(uploadedFile, "uploadedFile")
//     const dispatch = useDispatch()
//     const { createEducation } = useSelector(state => state?.createEducation);
//     const { updateEducation } = useSelector(state => state?.updateEducation);
//     const [inputValue, setInputValue] = useState("");
//     const [localValues, setLocalValues] = useState([]);

//     console.log(skillsData, "skillsData")



//     useEffect(() => {
//         setLocalValues(skillsData)
//     }, [skillsData]);

//     const sessionUserId = sessionStorage.getItem("userId")
//     const handleCrate = async (values, { resetForm }) => {

//         if (skillsData) {
//             const data1 = {
//                 data: {
//                     user_id: sessionUserId,

//                     skills: values?.skills,

//                 },
//                 method: "put",
//                 apiName: `updateUserStoreInfo/${sessionUserId}`,
//             };
//             const response = await dispatch(actions.UPDATEUSERSTOREINFO(data1));
//             console.log(response, "responsedataaaaaaa")
//             if (response?.payload?.message === "Store info updated.") {
//                 toast?.success('Skills updated successfully.')
//                 setTimeout(() => {
//                     onClose()
//                     resetForm()
//                     // setUploadedFile(null)
//                 }, 1500)
//             } else {
//                 toast.error(response?.payload?.message)
//             }
//         }



//     }


//     // useEffect(() => {

//     //     if (awardEditId !== null) {

//     //         const fetchData = async () => {
//     //             const data1 = {
//     //                 data: {},
//     //                 method: "get",
//     //                 apiName: `getAwardById/${awardEditId}`,
//     //             };
//     //             const response = await dispatch(actions.GETAWARDBYID(data1));
//     //         }
//     //         fetchData()
//     //     }

//     // }, [awardEditId]);



//     return (
//         <Dialog
//             open={open}
//             onClose={() => {
//                 onClose()
//                 setSkillsData(null)

//             }
//             }
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 maxWidth: "400px",
//                 // height:""
//                 margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: "relative" }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={() => {
//                             onClose()
//                             setSkillsData(null)

//                         }}
//                         sx={{
//                             position: "absolute",
//                             top: 8,
//                             right: 8,
//                             color: 'white',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Box>
//                             <Typography variant="subtitle1" sx={{ color: "white" }}>Add Experience</Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>
//                 <DialogContent sx={{ overflowY: "scroll", height: "200px" }}>
//                     {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
//                         <CancelSharp
//                             style={{ display: { sx: "none", md: "block" } }}
//                             // onClick={() => {
//                             //     navigate("/")
//                             // }}
//                         />
//                     </Box> */}
//                     <Grid
//                         item
//                         size={{ md: 5, xs: 12 }}


//                         sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             // p: 2,
//                             background: '#FFFFFF',
//                             width: '100%',

//                         }}
//                     >

//                         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5, alignItems: "center", height: "70vh" }}>
//                             {loading && <FullPageLoader />}

//                             <Card sx={{ width: '90%', maxWidth: 800, boxShadow: 3 }}>
//                                 <CardContent>
//                                     <Typography variant="h6" gutterBottom>Upload Your Resume (PDF)</Typography>
//                                     <Divider />
//                                     <Box
//                                         sx={{
//                                             p: 3,
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             justifyContent: 'center',
//                                             alignItems: 'center',
//                                             bgcolor: '#f5f5f5',
//                                         }}
//                                     >
//                                         <Formik
//                                             initialValues={{ resume: null }}
//                                             onSubmit={handleSubmit}
//                                         >
//                                             {({ setFieldValue, values, resetForm }) => (
//                                                 <Form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                                     {!values.resume ? (
//                                                         <Button
//                                                             component="label"
//                                                             variant="outlined"
//                                                             sx={{
//                                                                 display: 'flex',
//                                                                 flexDirection: 'column',
//                                                                 alignItems: 'center',
//                                                                 py: 4,
//                                                                 px: 6,
//                                                                 borderRadius: 2,
//                                                                 borderStyle: 'dashed',
//                                                                 borderColor: 'gray',
//                                                                 bgcolor: '#fff',
//                                                                 cursor: 'pointer',
//                                                                 textTransform: 'none',
//                                                                 '&:hover': {
//                                                                     borderColor: 'primary.main',
//                                                                     bgcolor: '#f0f0f0',
//                                                                 },
//                                                             }}
//                                                         >
//                                                             <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
//                                                             <Typography variant="h6" mt={1}>
//                                                                 Upload PDF
//                                                             </Typography>
//                                                             <input
//                                                                 type="file"
//                                                                 hidden
//                                                                 accept=".pdf"
//                                                                 onChange={(e) => handleFileChange(e, setFieldValue)}
//                                                             />
//                                                         </Button>
//                                                     ) : (
//                                                         <Paper elevation={3} sx={{ p: 2, mt: 3, textAlign: 'center', width: 300 }}>
//                                                             <PictureAsPdfIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
//                                                             <Typography variant="subtitle1" fontWeight="bold" mt={1}>
//                                                                 {values.resume.name}
//                                                             </Typography>
//                                                             <Typography variant="body2" color="text.secondary">
//                                                                 {values.resume.type}
//                                                             </Typography>

//                                                             <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
//                                                                 <IconButton color="primary" onClick={() => setOpenModal(true)}>
//                                                                     <VisibilityIcon />
//                                                                 </IconButton>
//                                                                 <IconButton color="success" onClick={() => handleDownload(values.resume)}>
//                                                                     <DownloadIcon />
//                                                                 </IconButton>
//                                                                 <IconButton color="error" onClick={() => {
//                                                                     resetForm();
//                                                                     setPreviewUrl(null);
//                                                                     setOpenModal(false);
//                                                                 }}>
//                                                                     <DeleteIcon />
//                                                                 </IconButton>
//                                                             </Stack>
//                                                             {/* <Button type='submit'>Submit</Button> */}
//                                                         </Paper>
//                                                     )}

//                                                     {values.resume && (
//                                                         <Button
//                                                             // type="submit"
//                                                             variant="contained"
//                                                             color="var(--main-color)"
//                                                             type="submit"
//                                                             sx={{ mt: 3, px: 4, background: "var(--main-color)", color: "white" }}
//                                                         >
//                                                             Save
//                                                         </Button>
//                                                     )}
//                                                 </Form>
//                                             )}
//                                         </Formik>

//                                         {/* PDF Preview Modal */}
//                                         <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth>
//                                             <DialogTitle>PDF Preview</DialogTitle>
//                                             <DialogContent>
//                                                 {previewUrl && (
//                                                     <iframe
//                                                         src={previewUrl}
//                                                         title="PDF Preview"
//                                                         width="100%"
//                                                         height="500px"
//                                                         style={{ border: 'none' }}
//                                                     />
//                                                 )}
//                                             </DialogContent>
//                                         </Dialog>
//                                     </Box>
//                                 </CardContent>
//                             </Card>
//                         </Box>
//                     </Grid>
//                 </DialogContent>
//                 <ToastContainer
//                     position="top-right"
//                     autoClose={1500}
//                     hideProgressBar={false}
//                     newestOnTop={false}
//                     closeOnClick
//                     rtl={false}
//                     pauseOnFocusLoss
//                     draggable
//                     pauseOnHover
//                     theme="dark"
//                 />


//             </Box>
//         </Dialog >
//     );
// };

// export default EditProfileAboutMeModal;

import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
    Paper,
    Stack
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import { Formik, Form } from "formik";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import ImageIcon from '@mui/icons-material/Image';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import actions from "../../../ReduxStore/actions";
import { adminUrl } from "../../../constants";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";

const EditProfileAboutMeModal = ({
    open,
    onClose,
    setSkillsData,
}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const sessionUserId = sessionStorage.getItem("userId")
    const { getUserAbout } = useSelector(
        (state) => state?.getUserAbout
    );

    const handleSubmit = async (values, { resetForm }) => {
        const data1 = {
            data: {
                about: values?.aboutme

            },
            method: "put",
            apiName: `updateUserStoreInfo/${sessionUserId}`,
        };
        const response = await dispatch(actions.UPDATEUSERSTOREINFO(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Store info updated.") {
            toast?.success('About you updated successfully.')
            setTimeout(() => {
                onClose()
                resetForm()
                // setUploadedFile(null)
                setPreviewUrl(null);

            }, 1500)
        } else {
            toast.error(response?.payload?.message)
        }

    };





    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose();
            }}
            fullWidth
            maxWidth="md"
            sx={{
                maxWidth: "500px",
                margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box sx={{ background: "var(--main-color)" }}>
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose();
                        }}
                        sx={{ position: "absolute", top: 8, right: 8, color: "white" }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle sx={{ color: "white" }}>
                        <Typography variant="subtitle1">
                            Update About you
                        </Typography>
                    </DialogTitle>
                </Box>

                <DialogContent sx={{ overflowY: "auto", height: "300px" }}>
                    <Grid>
                        <Box
                            sx={{
                                // display: "flex",
                                // justifyContent: "center",
                                // alignItems: "center",
                                mt: 5,
                                // margin:"auto 0",
                                // height: "200px" 
                            }}
                        >
                            <Formik
                                enableReinitialize
                                initialValues={{
                                     aboutme: getUserAbout?.data ||  "" 
                                    }}
                                onSubmit={handleSubmit}
                            >
                                {({ setFieldValue, values, resetForm }) => (
                                    <Form
                                    // style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                                    >
                                        <Grid size={{ xs: 12 }}>
                                            <CustomInputLogin
                                                name="aboutme"
                                                label="About"
                                                custPlaceholder="Enter about you"
                                                inputType="textarea"

                                            />
                                        </Grid>
                                        <Box
                                            sx={{
                                                // textTransform: "none",
                                                // background: "var(--main-color)",
                                                display: "flex",
                                                justifyContent: "end", alignItems: "end", mt: 2
                                            }}

                                        >
                                            <Button
                                                onClick={() => {
                                                    onClose()
                                                }}
                                                variant="contained"
                                                sx={{
                                                    textTransform: "none",
                                                    background: "white",
                                                    color: 'black',
                                                    mr: 2


                                                }}

                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                sx={{
                                                    textTransform: "none",
                                                    background: "var(--main-color)",

                                                }}

                                            >
                                                Update
                                            </Button>
                                        </Box>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </DialogContent>



                <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                />
            </Box>
        </Dialog>
    );
};

export default EditProfileAboutMeModal;
